/**
 * @generated SignedSource<<7c20dde8865a543c730bcf1ebedbe95d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type userProfileDetailFragment$data = {
  readonly id: string;
  readonly type: string;
  readonly roleId: string;
  readonly profileInformation: any | null;
  readonly profileSettings: any | null;
  readonly defaultSessionPassword: string;
  readonly zoomDetails: any | null;
  readonly clientLocations: any | null;
  readonly preferredVideoType: string | null;
  readonly googleCalendarSync: boolean;
  readonly signedAgreement: any | null;
  readonly setupCompletedAt: any | null;
  readonly specialities: {
    readonly approaches: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    } | null> | null;
    readonly areasOfExpertise: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    } | null> | null;
    readonly trackingOnlySpecialities: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    } | null> | null;
    readonly clientGroups: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    } | null> | null;
  } | null;
  readonly profileQuestionResponses: ReadonlyArray<{
    readonly id: string;
    readonly answer: string | null;
    readonly profileQuestion: {
      readonly id: string;
      readonly translationKey: string;
      readonly question: string;
    };
  }> | null;
  readonly " $fragmentSpreads": FragmentRefs<"userProfileApplicationStatusFragment">;
  readonly " $fragmentType": "userProfileDetailFragment";
};
export type userProfileDetailFragment$key = {
  readonly " $data"?: userProfileDetailFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"userProfileDetailFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "userProfileDetailFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "roleId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileInformation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileSettings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultSessionPassword",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "zoomDetails",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clientLocations",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "preferredVideoType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "googleCalendarSync",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signedAgreement",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "setupCompletedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CategorisedSpecialities",
      "kind": "LinkedField",
      "name": "specialities",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Speciality",
          "kind": "LinkedField",
          "name": "approaches",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Speciality",
          "kind": "LinkedField",
          "name": "areasOfExpertise",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Speciality",
          "kind": "LinkedField",
          "name": "trackingOnlySpecialities",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Speciality",
          "kind": "LinkedField",
          "name": "clientGroups",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfileQuestion",
      "kind": "LinkedField",
      "name": "profileQuestionResponses",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "answer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProfileQuestion",
          "kind": "LinkedField",
          "name": "profileQuestion",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "translationKey",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "question",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "userProfileApplicationStatusFragment"
    }
  ],
  "type": "UserProfileDetailConnect",
  "abstractKey": null
};
})();

(node as any).hash = "96dfd4bcf17c47613d506e57ef5e6af6";

export default node;
